var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "c-post-menu me-2" },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-light btn-sm me-1",
          attrs: { title: "confirm" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("thumbsup", _vm.post.id)
            },
          },
        },
        [_vm._v("👍\n    ")]
      ),
      _vm._v(" "),
      _vm.calendarData
        ? _c(
            "button",
            {
              staticClass: "btn btn-outline-light btn-sm",
              attrs: { title: "calendar" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.downloadInCalendar()
                },
              },
            },
            [_vm._v("📅\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.calendarData
        ? _c(
            "button",
            {
              staticClass: "btn btn-outline-light btn-sm me-1",
              attrs: { title: "like" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("like", _vm.post.id)
                },
              },
            },
            [_vm._v("❤️\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.likesOnly
        ? [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-light btn-sm",
                attrs: { title: "reply" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.$emit("reply", _vm.post.id)
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fas fa-reply",
                  staticStyle: { color: "grey" },
                }),
              ]
            ),
            _vm._v(" "),
            _vm.userId != _vm.post.user_id && !_vm.direct
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-light btn-sm",
                    attrs: { title: "reply private" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("reply-private", _vm.post.id)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-user-lock",
                      staticStyle: { color: "grey" },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.userId == _vm.post.user_id
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-light btn-sm",
                    attrs: { title: "edit" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("edit", _vm.post.id)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-edit",
                      staticStyle: { color: "grey" },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.userId == _vm.post.user_id
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-light btn-sm",
                    attrs: { title: "delete" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("delete", _vm.post.id)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-trash",
                      staticStyle: { color: "grey" },
                    }),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }